import { ChecklistItemFirestore } from 'models/ChecklistItem';
import { Checklist } from 'models/mapping/Checklist';
import { FirestoreService } from './firestore/FirestoreService';
import { FirestoreResponseChecklist, fromFirestoreToStore } from 'models/mapping/Checklist';
import { logFailure } from '../../app/utils/log'

export class ChecklistRepository {
  private static buildChecklistDocument({ item, itemSlug, sectionSlug, sectionType, editedByUser }: {
    item: ChecklistItemFirestore,
    itemSlug: string,
    sectionSlug: string,
    sectionType: string,
    editedByUser?: boolean,
  }) {
    const storedItem = editedByUser
      ? { value: item, editedByUser: true }
      : { value: item };

    return {
      sections: { [sectionType]: { [sectionSlug]: { items: { [itemSlug]: storedItem } } } },
    };
  }

  static async saveChecklistItem({ userId, item, itemSlug, sectionSlug, photoSessionId, sectionType, editedByUser }: {
    userId: number,
    item: ChecklistItemFirestore,
    itemSlug: string,
    sectionSlug: string,
    photoSessionId: number,
    sectionType: string,
    editedByUser?: boolean,
  }): Promise<any> {
    const checklistDocument = this.buildChecklistDocument({
      item,
      itemSlug,
      sectionSlug,
      sectionType,
      editedByUser,
    });

    const checklistSectionPath = FirestoreService.getChecklistDocumentPath({
      userId,
      photoSessionId,
    });

    try {
      const firestore = await FirestoreService.getInstance();
      const docReference = firestore.doc(checklistSectionPath);
      return docReference.set(checklistDocument, { merge: true });
    } catch (err) {
      logFailure({ message: err.message, state: undefined, payload: undefined });
      return Promise.resolve();
    }
  }

  static async getChecklist({ userId, photoSessionId }: { userId: number, photoSessionId: number }): Promise<Checklist> {
    const checklistPath = FirestoreService.getChecklistDocumentPath({ userId, photoSessionId });

    const firestore = await FirestoreService.getInstance();
    const checklistDocumentSnapshot = await firestore.doc(checklistPath).get();
    if (!checklistDocumentSnapshot.exists) {
      return undefined;
    }
    const checklistFirestore = checklistDocumentSnapshot.data();

    return fromFirestoreToStore(checklistFirestore.sections as FirestoreResponseChecklist);
  }
}
